import { cva } from "class-variance-authority"

// =============================================================================
// Styles
// =============================================================================
export const buttonBaseConfig = {
  base: "shrink-0 group/button outline-2 outline-offset-2 outline-transparent inline-flex items-center text-sm leading-6 font-semibold transition-colors [&_svg]:pointer-events-none [&_svg]:shrink-0 focus-visible:outline-gray-900",
  variants: {
    variant: {
      primary: "bg-gray-900 text-white hover:bg-gray-800",
      brand:
        "bg-blue-500 text-gray-900 [&_svg]:text-gray-800 hover:bg-blue-400",
      secondary:
        "bg-gray-900/6 text-gray-900 [&_svg]:text-gray-800 hover:bg-gray-900/12",
      outlined:
        "inset-ring inset-ring-gray-200 bg-white text-gray-900 [&_svg]:text-gray-800 hover:bg-gray-900/6",
      tertiary:
        "bg-transparent text-gray-900 [&_svg]:text-gray-800 hover:bg-gray-900/6"
    },
    size: {
      small:
        "rounded-sm p-1 gap-1 [&:not(:has(svg,[data-icon]))]:px-3 has-data-[icon=inline-start]:pl-2 has-data-[icon=inline-start]:pr-3 has-data-[icon=inline-end]:pl-3 has-data-[icon=inline-end]:pr-2",
      medium:
        "rounded p-2 gap-2 [&:not(:has(svg,[data-icon]))]:px-4 has-data-[icon=inline-start]:pl-3 has-data-[icon=inline-start]:pr-4 has-data-[icon=inline-end]:pl-4 has-data-[icon=inline-end]:pr-3",
      large:
        "rounded-lg p-3 gap-3 [&:not(:has(svg,[data-icon]))]:px-5 has-data-[icon=inline-start]:pl-4 has-data-[icon=inline-start]:pr-5 has-data-[icon=inline-end]:pl-5 has-data-[icon=inline-end]:pr-4"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "medium"
  }
} as const

export const buttonBaseStyles = cva(buttonBaseConfig.base, buttonBaseConfig)
